// TODO: Should I be using this, or just use local storage directly?
import { storage } from '../../auth/utils';

const TWITTER_AUTH_URL = 'https://api.twitter.com/oauth/authorize';

class TwitterSettingsController {
  constructor(TwitterUser, toaster, $http, $state, $window) {
    'ngInject';
    this.TwitterUser = TwitterUser;
    this.toaster = toaster;
    this.$http = $http;
    this.$state = $state;
    this.$window = $window;

    if ($state.params.link) {
      this._linkAccount();
    } else {
      const urlParams = new URLSearchParams($window.location.search);
      const denied = urlParams.get('denied');
      const oauthToken = urlParams.get('oauth_token');
      const oauthVerifier = urlParams.get('oauth_verifier');
      if ((oauthToken && oauthVerifier) || denied) {
        this._handleOauthCallback(oauthToken, oauthVerifier, denied);
      } else {
        $state.go('settings.integrations');
      }
    }
  }

  _handleOauthCallback(token, verifier, denied) {
    if (denied) return this._handleLinkError('Authorize was denied');
    if (!token) return this._handleLinkError('Missing oauth_token');
    if (!verifier) return this._handleLinkError('Missing oauth_verifier');
    const storedToken = storage.get('twitterToken');
    if (storedToken != token) return this._handleLinkError('Unexpected oauth_token');
    const secret = storage.get('twitterTokenSecret');
    const user = new this.TwitterUser({ token: token, secret: secret, verifier: verifier });
    const promise = user
      .$save()
      .then((u) => {
        const l = this.$window.location;
        l.href =
          l.protocol +
          '//' +
          l.host +
          l.pathname +
          `#/settings/integrations?integration_id=${u.id}`;
      })
      .catch((err) => this._handleLinkError(err));
    this.loadingPromises = [promise];
  }

  _linkAccount() {
    const promise = this.$http
      .post(`${API_ROOT}/twitter/oauth/request_token`, { oauth_callback: TWITTER_OAUTH_REDIRECT })
      .then(
        (resp) => this._requestTokenResponse(resp.data),
        (err) => this._handleLinkError(err)
      );
    this.loadingPromises = [promise];
  }

  _handleLinkError(errorMsg, obj) {
    console.error(...[errorMsg, obj].filter((e) => e));
    this.toaster.pop(
      'warning',
      'Unable to link the requested Twitter account. Please reload this page and try again.'
    );
  }

  _requestTokenResponse(resp) {
    // Ok, got a request token! Let's make sure it's confirmed
    if (!resp.oauth_callback_confirmed || !resp.oauth_token || !resp.oauth_token_secret) {
      return this._handleLinkError('Request token request failed', resp);
    }
    const twitterToken = resp.oauth_token;
    const twitterTokenSecret = resp.oauth_token_secret;

    // Ok, callback confirmed. Store the token and secret in local storage for later.
    storage.set('twitterToken', twitterToken);
    storage.set('twitterTokenSecret', twitterTokenSecret);

    // Send to oauth/authorize?oauth_token=XXX (Step 2); they'll come back with a token and a verifier
    window.location.replace(TWITTER_AUTH_URL + '?oauth_token=' + twitterToken);
  }
}

export default TwitterSettingsController;



// WEBPACK FOOTER //
// ./app/pages/settings/twitter.js